import type WebMap from '@arcgis/core/WebMap';
import TileInfo from '@arcgis/core/layers/support/TileInfo';

import { ScalesDictionaryReducedToBigCountries } from './ScalesDictionary';

export const ConfigureLevelOfDetails = (map: WebMap) => {
  const tileInfo = TileInfo.create({
    spatialReference: map.initialViewProperties.spatialReference,
    numLODs: ScalesDictionaryReducedToBigCountries.length
  });

  tileInfo.lods.forEach((lod: { scale: number }, index: number) => {
    lod.scale = ScalesDictionaryReducedToBigCountries[index].scale;
  });

  return tileInfo.lods;
};
